import firebase from "firebase/app";
import "firebase/firestore";
import {
  ORDER_OPEN,
  ORDER_PREPARING,
  ORDER_DELIVERING,
  ORDER_READY
} from "@/constants/order";
import Order from "@/models/Order";

const state = {
  location: null,
  order: [],
  completedOrderId: null,
  openOrderStatus: null,
  openOrders: []
};

const getters = {
  orderLocation({ location }) {
    return location;
  },

  itemsCount({ order }) {
    return order.length;
  },

  orderItems({ order }) {
    return order;
  },

  openOrderStatus({ openOrderStatus }) {
    return openOrderStatus;
  },

  openOrders({ openOrders }) {
    return openOrders;
  }
};

const mutations = {
  /**
   * Set the order location
   */
  setOrderLocation(state, location) {
    state.location = location;
  },

  addItemToOrder(state, { id, quantity, instructions, optionValueId }) {
    state.order.push({
      id,
      quantity,
      instructions,
      optionValueId
    });
  },

  clearOrder(state) {
    state.order = [];
    state.completedOrderId = null;
  },

  updateQuantity(state, { index, quantity }) {
    if (quantity > 0) {
      state.order[index].quantity = quantity;
    } else {
      state.order.splice(index, 1);
    }
  },

  setCompletedOrderId(state, id) {
    state.completedOrderId = id;
  },

  setOpenOrderStatus(state, status) {
    state.openOrderStatus = status;
  },

  setOpenOrders(state, openOrders) {
    state.openOrders = openOrders;
  }
};

let watcher = () => {};

const actions = {
  initializeOpenOrderWatcher({ rootState, commit }) {
    if (!rootState.auth.user) {
      return;
    }
    let uid = rootState.auth.user.uid;

    let query = firebase
      .firestore()
      .collection("orders")
      .withConverter(Order.firebaseConverter)
      .where("userId", "==", uid)
      .where("status", "in", [
        ORDER_OPEN,
        ORDER_PREPARING,
        ORDER_DELIVERING,
        ORDER_READY
      ]);

    watcher = query.onSnapshot(querySnapshot => {
      let openOrders = [];
      if (querySnapshot.size) {
        querySnapshot.forEach(doc => {
          let order = doc.data();
          openOrders.push(order);

          // if there are multiple, we just grab the status of the last one in the list
          // not perfect, but very unlikely there's multiple ones
          commit("setOpenOrderStatus", order.status);
        });
      } else {
        commit("setOpenOrderStatus", null);
      }
      commit("setOpenOrders", openOrders);
    });
  },

  clearAllOrderData({ commit }) {
    commit("setOpenOrders", []);
    commit("setOpenOrderStatus", null);
    watcher();
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
